import React, { useRef } from "react";
import { S } from "./theme";

// A date box that shows 21-Nov-2026 (the browser's own date box shows dd/mm/yyyy and cannot be changed).
// The saved value is still 2026-11-21. Click the box to open the calendar.
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const fmtDateBox = (d) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(d || "");
  return m ? m[3] + "-" + MONTHS[Number(m[2]) - 1] + "-" + m[1] : d || "";
};

export default function DateBox({ value, onChange, style, title, placeholder, max, min }) {
  const ref = useRef(null);
  const open = () => {
    try { if (ref.current && ref.current.showPicker) ref.current.showPicker(); else if (ref.current) ref.current.focus(); } catch (e) { /* ignore */ }
  };
  return (
    <div style={{ position: "relative", display: "inline-block", width: style && style.width ? style.width : "100%" }}>
      <div
        style={{ ...S.input, color: value ? "#e8eaf6" : "#7b82a0", ...style, cursor: "pointer", boxSizing: "border-box", userSelect: "none", minHeight: 20 }}
        onClick={open}
        title={title}
      >
        {value ? fmtDateBox(value) : placeholder || "Pick a date"}
      </div>
      <input
        ref={ref}
        type="date"
        value={value || ""}
        max={max}
        min={min}
        onChange={(e) => onChange(e.target.value)}
        tabIndex={-1}
        aria-hidden="true"
        style={{ position: "absolute", left: 0, bottom: 0, width: "100%", height: 1, opacity: 0, pointerEvents: "none" }}
      />
    </div>
  );
}
